<div class="card card-statistics mb-30">
  <div class="card-body">
    <h5 class="card-title">فرم ویرایش اطلاعات سوابق پرسنلی</h5>

    <form [formGroup]="Form_List_Hasilat_Record" (submit)="onSubmitTahsimla()">
      <h4>تحصیلات</h4>
      <br>
      <div class="row">
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">از سال/ماه</label>
          <input formControlName="date_starrt" type="text" class="form-control" placeholder="اینجا تایپ کنید ...">
          <small
            *ngIf="!get_Form_List_Hasilat_Record_date_starrt().valid && get_Form_List_Hasilat_Record_date_starrt().touched"
            class="form-text text-muted MyErrorRedColor">از سال/ماه را وارد نمائید.</small>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">تا سال/ماه</label>
          <input formControlName="date_end" type="text" class="form-control" placeholder="اینجا تایپ کنید ...">
          <small
            *ngIf="!get_Form_List_Hasilat_Record_date_end().valid && get_Form_List_Hasilat_Record_date_end().touched"
            class="form-text text-muted MyErrorRedColor">تا سال/ماه را وارد نمائید.</small>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">مقطع</label>
          <input formControlName="degree" type="text" class="form-control" placeholder="اینجا تایپ کنید ...">
          <small *ngIf="!get_Form_List_Hasilat_Record_degree().valid && get_Form_List_Hasilat_Record_degree().touched"
            class="form-text text-muted MyErrorRedColor">مقطع را وارد نمائید.</small>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">رشته تحصیلی</label>
          <input formControlName="reshteh" type="text" class="form-control" placeholder="اینجا تایپ کنید ...">
          <small *ngIf="!get_Form_List_Hasilat_Record_reshteh().valid && get_Form_List_Hasilat_Record_reshteh().touched"
            class="form-text text-muted MyErrorRedColor">رشته تحصیلی را وارد نمائید.</small>
        </div>

      </div>
      <div class="row">
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">گرایش</label>
          <input formControlName="grayesh" type="text" class="form-control" placeholder="اینجا تایپ کنید ...">
          <small *ngIf="!get_Form_List_Hasilat_Record_grayesh().valid && get_Form_List_Hasilat_Record_grayesh().touched"
            class="form-text text-muted MyErrorRedColor">گرایش را وارد نمائید.</small>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">دانشگاه/موسسه آموزش عالی</label>
          <input formControlName="uni" type="text" class="form-control" placeholder="اینجا تایپ کنید ...">
          <small *ngIf="!get_Form_List_Hasilat_Record_uni().valid && get_Form_List_Hasilat_Record_uni().touched"
            class="form-text text-muted MyErrorRedColor">دانشگاه/موسسه آموزش عالی را وارد نمائید.</small>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">معدل</label>
          <input formControlName="moadel" type="text" class="form-control" placeholder="اینجا تایپ کنید ...">
          <small *ngIf="!get_Form_List_Hasilat_Record_moadel().valid && get_Form_List_Hasilat_Record_moadel().touched"
            class="form-text text-muted MyErrorRedColor">معدل را وارد نمائید.</small>
        </div>

        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">
            بارگذاری مدرک تحصیلی
            <button (click)="Remove_uploadax_Hasilat_Image()" type="button" *ngIf="ax_Hasilat_Image"
              class="btn  btn-danger"><i class="fa  fa-times-rectangle"></i> </button>
          </label>
          <img *ngIf="InProccessing_ax_Hasilat_Image" src="assets/Loading.gif" style="width: 25px;" />
          <input *ngIf="!InProccessing_ax_Hasilat_Image" #file_ax_Hasilat_Image
            (change)="uploadax_Hasilat_Image(file_ax_Hasilat_Image.files)" type="file" class="form-control"
            placeholder="اینجا تایپ کنید ...">
          <img (click)="openModal(templateImage,ax_Hasilat_Image)" *ngIf="ax_Hasilat_Image"
            style="width: 150px;cursor: zoom-in;" src="{{BaseUrl}}File/Person/{{ax_Hasilat_Image}}" />
        </div>
      </div>

      <button type="submit" [disabled]="!Form_List_Hasilat_Record.valid" class="btn btn-success"
        style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> افرودن اطلاعات تحصیلی </button>

    </form>

    <div class="table-responsive" *ngIf="Data_Tahsilat_List.length>0">
      <table class="mb-0 table table-bordered table-3 text-center table-striped">
        <thead style="background-color: #489b39; color: white;">
          <tr>
            <th>#</th>
            <th>از سال/ماه</th>
            <th>تا سال/ماه</th>
            <th>مقطع</th>
            <th>رشته تحصیلی</th>
            <th>گرایش</th>
            <th>دانشگاه/موسسه آموزش عالی</th>
            <th>معدل</th>
            <th>مدرک تحصیلی</th>
            <th>امکانات</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of Data_Tahsilat_List">
            <td>{{Data_Tahsilat_List.indexOf(item)+1}}</td>
            <td>{{item.date_starrt}}</td>
            <td>{{item.date_end}}</td>
            <td>{{item.degree}}</td>
            <td>{{item.reshteh}}</td>
            <td>{{item.grayesh}}</td>
            <td>{{item.uni}}</td>
            <td>{{item.moadel}}</td>
            <td>
              <img (click)="openModal(templateImage,item.image)" *ngIf="item.image"
                style="width: 150px;cursor: zoom-in;" src="{{BaseUrl}}File/Person/{{item.image}}" />
            </td>

            <td>
              <div class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
                <div class="btn-group" role="group">
                  <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    امکانات
                  </button>
                  <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                    <a style="cursor: pointer;" (click)="RemoveTahsimla(Data_Tahsilat_List.indexOf(item))"
                      class="dropdown-item"><i class="fa fa-remove"></i> حذف </a>
                  </div>
                </div>
              </div>
            </td>

          </tr>
        </tbody>
      </table>
    </div>

    <br>
    <br>
    <hr>
    <br>

    <form [formGroup]="Form_List_kari_Record" (submit)="onSubmitkari()">
      <h4>سوابق کاری(5 سال گذشته)</h4>
      <br>
      <div class="row">
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">از سال/ماه</label>
          <input formControlName="date_starrt" type="text" class="form-control" placeholder="اینجا تایپ کنید ...">
          <small
            *ngIf="!get_Form_List_kari_Record_date_starrt().valid && get_Form_List_kari_Record_date_starrt().touched"
            class="form-text text-muted MyErrorRedColor">از سال/ماه را وارد نمائید.</small>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">تا سال/ماه</label>
          <input formControlName="date_end" type="text" class="form-control" placeholder="اینجا تایپ کنید ...">
          <small *ngIf="!get_Form_List_kari_Record_date_end().valid && get_Form_List_kari_Record_date_end().touched"
            class="form-text text-muted MyErrorRedColor">تا سال/ماه را وارد نمائید.</small>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">نام شرکت/سازمان</label>
          <input formControlName="companyName" type="text" class="form-control" placeholder="اینجا تایپ کنید ...">
          <small
            *ngIf="!get_Form_List_kari_Record_companyName().valid && get_Form_List_kari_Record_companyName().touched"
            class="form-text text-muted MyErrorRedColor">نام شرکت/سازمان را وارد نمائید.</small>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">نوع استخدام</label>
          <input formControlName="type" type="text" class="form-control" placeholder="اینجا تایپ کنید ...">
          <small *ngIf="!get_Form_List_kari_Record_type().valid && get_Form_List_kari_Record_type().touched"
            class="form-text text-muted MyErrorRedColor">نوع استخدام را وارد نمائید.</small>
        </div>

      </div>
      <div class="row">
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">سمت</label>
          <input formControlName="semat" type="text" class="form-control" placeholder="اینجا تایپ کنید ...">
          <small *ngIf="!get_Form_List_kari_Record_semat().valid && get_Form_List_kari_Record_semat().touched"
            class="form-text text-muted MyErrorRedColor">سمت را وارد نمائید.</small>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">علت ترک خدمت</label>
          <input formControlName="leave" type="text" class="form-control" placeholder="اینجا تایپ کنید ...">
          <small *ngIf="!get_Form_List_kari_Record_leave().valid && get_Form_List_kari_Record_leave().touched"
            class="form-text text-muted MyErrorRedColor">علت ترک خدمت را وارد نمائید.</small>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">تلفن</label>
          <input formControlName="tel" type="text" class="form-control" placeholder="اینجا تایپ کنید ...">
          <small *ngIf="!get_Form_List_kari_Record_tel().valid && get_Form_List_kari_Record_tel().touched"
            class="form-text text-muted MyErrorRedColor">تلفن را وارد نمائید.</small>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">آدرس</label>
          <input formControlName="address" type="text" class="form-control" placeholder="اینجا تایپ کنید ...">
          <small *ngIf="!get_Form_List_kari_Record_address().valid && get_Form_List_kari_Record_address().touched"
            class="form-text text-muted MyErrorRedColor">آدرس را وارد نمائید.</small>
        </div>
      </div>

      <button type="submit" [disabled]="!Form_List_kari_Record.valid" class="btn btn-success"
        style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> افرودن اطلاعات سوابق کاری </button>

    </form>

    <div class="table-responsive" *ngIf="Data_Kari_List.length>0">
      <table class="mb-0 table table-bordered table-3 text-center table-striped">
        <thead style="background-color: #489b39; color: white;">
          <tr>
            <th>#</th>
            <th>از سال/ماه</th>
            <th>تا سال/ماه</th>
            <th>نام شرکت/سازمان</th>
            <th>نوع استخدام</th>
            <th>سمت</th>
            <th>علت ترک خدمت</th>
            <th>تلفن</th>
            <th>آدرس</th>
            <th>امکانات</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of Data_Kari_List">
            <td>{{Data_Kari_List.indexOf(item)+1}}</td>
            <td>{{item.date_starrt}}</td>
            <td>{{item.date_end}}</td>
            <td>{{item.companyName}}</td>
            <td>{{item.type}}</td>
            <td>{{item.semat}}</td>
            <td>{{item.leave}}</td>
            <td>{{item.tel}}</td>
            <td>{{item.address}}</td>

            <td>
              <div class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
                <div class="btn-group" role="group">
                  <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    امکانات
                  </button>
                  <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                    <a style="cursor: pointer;" (click)="RemoveKari(Data_Kari_List.indexOf(item))"
                      class="dropdown-item"><i class="fa fa-remove"></i> حذف </a>
                  </div>
                </div>
              </div>
            </td>

          </tr>
        </tbody>
      </table>
    </div>

    <br>
    <br>
    <hr>
    <br>

    <form [formGroup]="Form_List_Amoozeshi_Record" (submit)="onSubmitAmozeshi()">
      <h4>سوابق آموزش</h4>
      <br>
      <div class="row">
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">از سال/ماه</label>
          <input formControlName="date_starrt" type="text" class="form-control" placeholder="اینجا تایپ کنید ...">
          <small
            *ngIf="!get_Form_List_Amoozeshi_Record_date_starrt().valid && get_Form_List_Amoozeshi_Record_date_starrt().touched"
            class="form-text text-muted MyErrorRedColor">از سال/ماه را وارد نمائید.</small>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">تا سال/ماه</label>
          <input formControlName="date_end" type="text" class="form-control" placeholder="اینجا تایپ کنید ...">
          <small
            *ngIf="!get_Form_List_Amoozeshi_Record_date_end().valid && get_Form_List_Amoozeshi_Record_date_end().touched"
            class="form-text text-muted MyErrorRedColor">تا سال/ماه را وارد نمائید.</small>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">سرفصل دوره آموزشی</label>
          <select class="custom-select" formControlName="sarFaslAmozeshi_id" (change)="ReadData_DorehAmoozeshi()">
            <option value="0">انتخاب کنید</option>
            <option *ngFor="let item of DataList_SarFaslAmozeshi" [value]="item.id">{{item.title}}</option>
          </select>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">عنوان دوره آموزشی</label>
          <select class="custom-select" formControlName="dorehAmoozeshi_id">
            <option value="0">انتخاب کنید</option>
            <option *ngFor="let item of DataList_DorehAmoozeshi" [value]="item.id">{{item.title}}</option>
          </select>
        </div>

      </div>
      <div class="row">
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">مدت(ساعت)</label>
          <input formControlName="modat" type="number" class="form-control" placeholder="اینجا تایپ کنید ...">
          <small *ngIf="!get_Form_List_Amoozeshi_Record_modat().valid && get_Form_List_Amoozeshi_Record_modat().touched"
            class="form-text text-muted MyErrorRedColor">مدت(ساعت) را وارد نمائید.</small>
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">برگزار کننده</label>
          <input formControlName="bargozarKonnadeh" type="text" class="form-control" placeholder="اینجا تایپ کنید ...">
          <small
            *ngIf="!get_Form_List_Amoozeshi_Record_bargozarKonnadeh().valid && get_Form_List_Amoozeshi_Record_bargozarKonnadeh().touched"
            class="form-text text-muted MyErrorRedColor">برگزار کننده را وارد نمائید.</small>
        </div>

        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">
            بارگذاری مدرک تحصیلی
            <button (click)="Remove_uploadax_Amoozeshi_Image()" type="button" *ngIf="ax_Amoozeshi_Image"
              class="btn  btn-danger"><i class="fa  fa-times-rectangle"></i> </button>
          </label>
          <img *ngIf="InProccessing_ax_Amoozeshi_Image" src="assets/Loading.gif" style="width: 25px;" />
          <input *ngIf="!InProccessing_ax_Amoozeshi_Image" #file_ax_Amoozeshi_Image
            (change)="uploadax_Amoozeshi_Image(file_ax_Amoozeshi_Image.files)" type="file" class="form-control"
            placeholder="اینجا تایپ کنید ...">
          <img (click)="openModal(templateImage,ax_Amoozeshi_Image)" *ngIf="ax_Amoozeshi_Image"
            style="width: 150px;cursor: zoom-in;" src="{{BaseUrl}}File/Person/{{ax_Amoozeshi_Image}}" />
        </div>
      </div>

      <button type="submit" [disabled]="!Form_List_Amoozeshi_Record.valid" class="btn btn-success"
        style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> افرودن اطلاعات سوابق آموزش </button>

    </form>

    <div class="table-responsive" *ngIf="Data_Amoozeshi_List.length>0">
      <table class="mb-0 table table-bordered table-3 text-center table-striped">
        <thead style="background-color: #489b39; color: white;">
          <tr>
            <th>#</th>
            <th>از سال/ماه</th>
            <th>تا سال/ماه</th>
            <th>سرفصل دوره آموزشی</th>
            <th>عنوان دوره آموزشی</th>
            <th>مدت(ساعت)</th>
            <th>برگزار کننده</th>
            <th>مدرک تحصیلی</th>
            <th>امکانات</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of Data_Amoozeshi_List">
            <td>{{Data_Amoozeshi_List.indexOf(item)+1}}</td>
            <td>{{item.date_starrt}}</td>
            <td>{{item.date_end}}</td>
            <td>{{item.sarFaslAmozeshiTitle}}</td>
            <td>{{item.dorehAmoozeshiTitle}}</td>
            <td>{{item.modat}}</td>
            <td>{{item.bargozarKonnadeh}}</td>
            <td>
              <a target="_blank" *ngIf="item.image && item.image.includes('.pdf')" href="{{BaseUrl}}File/Person/{{item.image}}" class="btn btn-success"><i class="fa fa-file-pdf-o"></i> PDF </a>
                <img *ngIf="item.image && !item.image.includes('.pdf')" (click)="openModal(templateImage,item.image)"  style="width: 150px;cursor: zoom-in;" src="{{BaseUrl}}File/Person/{{item.image}}"/>
            </td>

            <td>
              <div class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
                <div class="btn-group" role="group">
                  <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    امکانات
                  </button>
                  <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                    <a style="cursor: pointer;" (click)="RemoveAmozeshi(Data_Amoozeshi_List.indexOf(item))"
                      class="dropdown-item"><i class="fa fa-remove"></i> حذف </a>
                  </div>
                </div>
              </div>
            </td>

          </tr>
        </tbody>
      </table>
    </div>

    <br>
    <br>
    <hr>
    <br>

    <form [formGroup]="Form_List_Skill_Record" (submit)="onSubmitSkill()">
      <h4>مهارت</h4>
      <br>
      <div class="row">

        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">مهارت</label>
          <select class="custom-select" formControlName="skill">
            <option value="0">انتخاب کنید</option>
            <option *ngFor="let item of DataList_Skill" [value]="item.id">{{item.title}}</option>
          </select>
        </div>
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">درصد</label>
          <input formControlName="percent" type="number" class="form-control" placeholder="اینجا تایپ کنید ...">
          <small *ngIf="!get_Form_List_Skill_Record_percent().valid && get_Form_List_Skill_Record_percent().touched"
            class="form-text text-muted MyErrorRedColor">درصد را وارد نمائید.</small>
        </div>

      </div>

      <button type="submit" [disabled]="!Form_List_Skill_Record.valid" class="btn btn-success"
        style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> افرودن اطلاعات مهارت </button>

    </form>

    <div class="table-responsive" *ngIf="Data_Skill_List.length>0">
      <table class="mb-0 table table-bordered table-3 text-center table-striped">
        <thead style="background-color: #489b39; color: white;">
          <tr>
            <th>#</th>
            <th>مهارت</th>
            <th>درصد</th>
            <th>امکانات</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of Data_Skill_List">
            <td>{{Data_Skill_List.indexOf(item)+1}}</td>
            <td>{{item.skillTitle}}</td>
            <td>{{item.percennt}}</td>
            <td>
              <div class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
                <div class="btn-group" role="group">
                  <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    امکانات
                  </button>
                  <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                    <a style="cursor: pointer;" (click)="RemoveSkill(Data_Skill_List.indexOf(item))"
                      class="dropdown-item"><i class="fa fa-remove"></i> حذف </a>
                  </div>
                </div>
              </div>
            </td>

          </tr>
        </tbody>
      </table>
    </div>

    <br>
    <br>
    <hr>
    <br>

    <form [formGroup]="Form_List_Tahghighat_Record" (submit)="onSubmitTahghighat()">
      <h4>تحقیقات</h4>
      <br>
      <div class="row">
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">عنوان</label>
          <input formControlName="title" type="text" class="form-control" placeholder="اینجا تایپ کنید ...">
          <small
            *ngIf="!get_Form_List_Tahghighat_Record_title().valid && get_Form_List_Tahghighat_Record_title().touched"
            class="form-text text-muted MyErrorRedColor">عنوان را وارد نمائید.</small>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">تاریخ</label>
          <input formControlName="tarikh" type="text" class="form-control" placeholder="اینجا تایپ کنید ...">
          <small
            *ngIf="!get_Form_List_Tahghighat_Record_tarikh().valid && get_Form_List_Tahghighat_Record_tarikh().touched"
            class="form-text text-muted MyErrorRedColor">تاریخ را وارد نمائید.</small>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">ناشر</label>
          <input formControlName="nasher" type="text" class="form-control" placeholder="اینجا تایپ کنید ...">
          <small
            *ngIf="!get_Form_List_Tahghighat_Record_nasher().valid && get_Form_List_Tahghighat_Record_nasher().touched"
            class="form-text text-muted MyErrorRedColor">ناشر را وارد نمائید.</small>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">لینک</label>
          <input formControlName="link" type="text" class="form-control" placeholder="اینجا تایپ کنید ...">
          <small *ngIf="!get_Form_List_Tahghighat_Record_link().valid && get_Form_List_Tahghighat_Record_link().touched"
            class="form-text text-muted MyErrorRedColor">لینک را وارد نمائید.</small>
        </div>

      </div>

      <button type="submit" [disabled]="!Form_List_Tahghighat_Record.valid" class="btn btn-success"
        style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> افرودن اطلاعات تحقیق </button>

    </form>

    <div class="table-responsive" *ngIf="Data_Tahghighat_List.length>0">
      <table class="mb-0 table table-bordered table-3 text-center table-striped">
        <thead style="background-color: #489b39; color: white;">
          <tr>
            <th>#</th>
            <th>عنوان</th>
            <th>تاریخ</th>
            <th>ناشر</th>
            <th>لینک</th>
            <th>امکانات</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of Data_Tahghighat_List">
            <td>{{Data_Tahghighat_List.indexOf(item)+1}}</td>
            <td>{{item.title}}</td>
            <td>{{item.tarikh}}</td>
            <td>{{item.nasher}}</td>
            <td>{{item.link}}</td>
            <td>
              <div class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
                <div class="btn-group" role="group">
                  <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    امکانات
                  </button>
                  <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                    <a style="cursor: pointer;" (click)="RemoveTahghighat(Data_Tahghighat_List.indexOf(item))"
                      class="dropdown-item"><i class="fa fa-remove"></i> حذف </a>
                  </div>
                </div>
              </div>
            </td>

          </tr>
        </tbody>
      </table>
    </div>

    <br>
    <br>
    <hr>
    <br>

    <form [formGroup]="Form_List_Document_Record" (submit)="onSubmitDocument()">
      <h4>مطالعه و درک اسناد</h4>
      <br>
      <div class="row">
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">گروه اسناد</label>
          <select class="custom-select" formControlName="grpDoc_id" (change)="ReadData_DocumentTitle()">
            <option value="0">انتخاب کنید</option>
            <option *ngFor="let item of DataList_DocumentGroup" [value]="item.id">{{item.title}}</option>
          </select>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">عنوان سند</label>
          <select class="custom-select" formControlName="tlDoc_id">
            <option value="0">انتخاب کنید</option>
            <option *ngFor="let item of DataList_DocumentTitle" [value]="item.id">{{item.title}}</option>
          </select>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">شماره ویرایش</label>
          <input formControlName="shomareh" type="text" class="form-control" placeholder="اینجا تایپ کنید ...">
          <small
            *ngIf="!get_Form_List_Document_Record_shomareh().valid && get_Form_List_Document_Record_shomareh().touched"
            class="form-text text-muted MyErrorRedColor">شماره ویرایش را وارد نمائید.</small>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">تأییدکننده</label>
          <input formControlName="taminKonandeh" type="text" class="form-control" placeholder="اینجا تایپ کنید ...">
          <small
            *ngIf="!get_Form_List_Document_Record_taminKonandeh().valid && get_Form_List_Document_Record_taminKonandeh().touched"
            class="form-text text-muted MyErrorRedColor">تأییدکننده را وارد نمائید.</small>
        </div>

      </div>

      <button type="submit" [disabled]="!Form_List_Document_Record.valid" class="btn btn-success"
        style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> افرودن اطلاعات مطالعه و درک اسناد </button>

    </form>

    <div class="table-responsive" *ngIf="Data_Document_List.length>0">
      <table class="mb-0 table table-bordered table-3 text-center table-striped">
        <thead style="background-color: #489b39; color: white;">
          <tr>
            <th>#</th>
            <th>گروه اسناد</th>
            <th>عنوان سند</th>
            <th>شماره ویرایش</th>
            <th>تأییدکننده</th>
            <th>امکانات</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of Data_Document_List">
            <td>{{Data_Document_List.indexOf(item)+1}}</td>
            <td>{{item.grpDocTitle}}</td>
            <td>{{item.tlDocTitle}}</td>
            <td>{{item.shomareh}}</td>
            <td>{{item.taminKonandeh}}</td>
            <td>
              <div class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
                <div class="btn-group" role="group">
                  <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    امکانات
                  </button>
                  <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                    <a style="cursor: pointer;" (click)="RemoveDocument(Data_Document_List.indexOf(item))"
                      class="dropdown-item"><i class="fa fa-remove"></i> حذف </a>
                  </div>
                </div>
              </div>
            </td>

          </tr>
        </tbody>
      </table>
    </div>

    <br>
    <br>

    <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!InProccessing" type="button" (click)="SubmitEditNewPerson()"
      class="btn btn-success" style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> ثبت اطلاعات </button>
    <button *ngIf="!InProccessing" type="reset" class="btn btn-danger" style="margin-left: 5px;"><i
        class="fa fa-times-rectangle"></i> لغو </button>
    <button routerLink="/Person1" *ngIf="!InProccessing" type="button" class="btn btn-warning"><i
        class="fa fa-mail-reply"></i> بازگشت </button>
  </div>
</div>


<ng-template #templateImage>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> نمایش عکس </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Image.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body" style="text-align: center;">
    <img style="max-width: 350px;" src="{{BaseUrl}}File/Person/{{ModalimageUrl}}" />
  </div>
  <div class="modal-footer">
    <a class="dropdown-item" target="_blank" href="{{BaseUrl}}File/Person/{{ModalimageUrl}}"><i
        class="fa fa-download"></i> دانلود </a>
    <button type="button" class="btn btn-danger" (click)="modalRef_Image.hide()">بستن</button>
  </div>
</ng-template>
